import CloseLineIcon from '@ben/icons/close-line';
import IconButton from '@ben/orion/icon-button';
import Input, { InputVariant } from '@ben/orion/input';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { Controller } from 'react-hook-form';
import { FormContainer, FormField, FormHeader, Spacer } from './styles';
import type { BaseRestrictionFormProps } from './types';

const FormulaBasedRestrictionForm = ({
  index,
  control,
  restrictionSetPath,
  onRemove,
}: BaseRestrictionFormProps) => {
  const basePath = `${restrictionSetPath}.formulaBasedRestrictions.${index}`;

  return (
    <FormContainer>
      <FormHeader>
        <Typography variant={TypographyVariant.bodyMd1}>
          Formula Based Restriction: #{index + 1}
        </Typography>
        <Spacer />
        <IconButton
          onClick={onRemove}
          aria-label="Remove restriction"
          icon={CloseLineIcon}
          size="sm"
          variant="action"
        />
      </FormHeader>

      <FormField>
        <Controller
          control={control}
          name={`${basePath}.formula`}
          rules={{ required: true, maxLength: 3000 }}
          render={({ field }) => (
            <Input
              name="Formula"
              showLabel
              variant={InputVariant.TextArea}
              value={field.value}
              onChange={field.onChange}
              maxLength={3000}
              width="100%"
            />
          )}
        />
      </FormField>

      <FormField>
        <Controller
          control={control}
          name={`${basePath}.message`}
          rules={{ required: true }}
          render={({ field }) => (
            <Input
              name="Validation message"
              showLabel
              variant={InputVariant.Text}
              value={field.value}
              onChange={field.onChange}
              width="100%"
            />
          )}
        />
      </FormField>
    </FormContainer>
  );
};

export default FormulaBasedRestrictionForm;
